/*eslint-disable*/
import React, { Component } from "react";
import classnames from "classnames";

import "./styles/index.scss";
import djprLogo from "./img/vic-logo.png";

class AustralianUnityLayout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { formId } = this.props;

    return (
      <div className="layout-djpr">
        <div className="wrapper">
          <main
            className={classnames("content", { [`form-id-${formId}`]: formId })}
          >
          <div key="claim-1" className="claim-header">
            <div className="container">
              <img className="claim-img-left" alt="" src={djprLogo} />
              <h3>
                Business Victoria Enquiry Form
              </h3>
            </div>
          </div>
            {this.props.children}
          </main>
        </div>
      </div>
    );
  }
}

export default AustralianUnityLayout;
